var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import { css } from "styled-components";
export var EXTRA_LARGE_DESKTOP = 1600;
export var LARGE_DESKTOP = 1200;
export var DESKTOP = 992;
export var TABLET = 768;
export var PHONE_LANDSCAPE = 576;
export var PHONE = 376;
export var sizes = {
    extraLargeDesktop: EXTRA_LARGE_DESKTOP - 1 + "px",
    largeDesktop: LARGE_DESKTOP - 1 + "px",
    desktop: DESKTOP - 1 + "px",
    tablet: TABLET - 1 + "px",
    phoneLandscape: PHONE_LANDSCAPE - 1 + "px",
    phone: PHONE - 1 + "px"
};
var minWidthsizes = {
    extraLargeDesktop: EXTRA_LARGE_DESKTOP + "px",
    largeDesktop: LARGE_DESKTOP + "px",
    desktop: DESKTOP + "px",
    tablet: TABLET + "px",
    phoneLandscape: PHONE_LANDSCAPE + "px",
    phone: PHONE + "px"
};
/** Match bootstrap's media queries, they work mobile first */
export var minWidthMedia = Object.keys(sizes).reduce(function (acc, label) {
    acc[label] = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        return css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    @media (min-width: ", ") {\n      ", "\n    }\n  "], ["\n    @media (min-width: ", ") {\n      ", "\n    }\n  "])), minWidthsizes[label], css.apply(void 0, args));
    };
    return acc;
}, {});
// Iterate through the sizes and create a media template
var maxWidthMedia = Object.keys(sizes).reduce(function (acc, label) {
    acc[label] = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        return css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    @media (max-width: ", ") {\n      ", "\n    }\n  "], ["\n    @media (max-width: ", ") {\n      ", "\n    }\n  "])), sizes[label], css.apply(void 0, args));
    };
    return acc;
}, {});
export default maxWidthMedia;
var templateObject_1, templateObject_2;
